import React, { ReactNode } from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import { Form } from '@ant-design/compatible';
import { ValidationRule } from '@ant-design/compatible/lib/form/Form';
import cx from 'classnames';
import Switch from '../../../../../components/input/Switch/Switch';

interface SwitchFormProps extends FormComponentProps {
  className?: string;
  label?: string | ReactNode;
  name: string;
  rules?: ValidationRule[];
  vertical?: boolean;
  initialValue?: boolean;
  onChange?: SwitchChangeEventHandler;
  disabled?: boolean;
  subContent?: string | ReactNode;
  showInfo?: boolean;
}
const SwitchForm = (props: SwitchFormProps) => {
  const {
    className,
    form,
    label,
    name,
    rules,
    vertical,
    initialValue,
    onChange,
    disabled,
    subContent,
    showInfo = true,
  } = props;
  const { getFieldDecorator } = form;

  return (
    <div className={className}>
      <Form.Item className={cx('switch-form', 'amondz-form', { 'with-label': label }, { vertical })} label={label}>
        {getFieldDecorator(name, {
          rules,
          initialValue,
          valuePropName: 'checked',
        })(<Switch onChange={onChange} disabled={disabled} />)}
      </Form.Item>

      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </div>
  );
};

export default SwitchForm;
